import { render } from "./UserTicketConversation.vue?vue&type=template&id=55dad22e&scoped=true"
import script from "./UserTicketConversation.vue?vue&type=script&lang=js"
export * from "./UserTicketConversation.vue?vue&type=script&lang=js"

import "./UserTicketConversation.vue?vue&type=style&index=0&id=55dad22e&scoped=true&lang=css"
import "./styles/chatComposer.css?vue&type=style&index=1&id=55dad22e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dad22e"]])

export default __exports__